

import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { isMobile, isDesktop, isIpad } from '../../global/ScreenSizeHelper'
import './StoreListTabs.scss'

export default function StoreListTabs(props) {
    const handleChange = (event, newValue) => {
        if (setValue) {
            setValue(newValue);
        }
    };

    const { tabNames = [], setValue, value, mobilePositionFixed = false, onChange = handleChange } = props




    return (
        <Tabs
            value={value}
            onChange={onChange}
            textColor="secondary"
            indicatorColor="secondary"
            aria-label="Vertical tabs example"
            variant="scrollable"
            scrollButtons={false}
            allowScrollButtonsMobile={isIpad ? true : true}
            className={isDesktop || isIpad ? 'storelist-tabs-container' : 'storelist-tabs-container-mobile'}
            orientation="horizontal"
        >
            {

                tabNames.map((tab) => {
                    return (<Tab sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }} value={tab} label={tab} key={tab} />)


                })
            }
        </Tabs>
    )


}
